import { List } from 'immutable';
import { effectSubscriber, queueEffectMiddleware } from './effects';
import { exportModule } from './module';
import { state } from './state';
export var composeAppCoreModule = function composeAppCoreModule(effects) {
  return exportModule({
    middleware: List([queueEffectMiddleware]),
    state: state,
    subscribers: List.of(effectSubscriber(effects))
  });
};